<template>
	<div class="centerx" style="min-width: 800px; z-index: 99999">
		<vs-popup
			:title="'Contrat N°' + contractId + ' ' + societyName"
			:active.sync="isPopupActive"
			style="z-index: 54000"
		>
			<div class="vx-col" style="min-width: 800px; padding-left: 30px">
				<div class="flex justify-between">
					<div class="w-1/2 bg-gray-200 p-4">
						<div>
							<div
								class="w-1/2"
								style="
									background-color: rgba(var(--vs-primary), 1);
									color: white;
									border-radius: 10px;
									padding: 5px;
									margin-bottom: 3px;
								"
							>
								<div class="vx-row w-full flex" style="justify-content: center">
									{{
										historicalProviders.length > 0
											? "Prestataire(s) historique(s)"
											: "Aucun prestataire historique"
									}}
								</div>
								<div class="vx-row w-full flex" style="justify-content: center">
									<div
										v-if="historicalProviders.length > 0"
										class="vx-row center-content"
										style="margin: 0"
									>
										<div
											class="flex center"
											v-for="(
												account_manager_avatar, index
											) in historicalProviders"
											:key="index"
										>
											<vx-tooltip
												:text="
													getProviderIdToName(account_manager_avatar.users_id)
												"
												position="top"
											>
												<vs-avatar
													style="border: 1px solid; border-color: white"
													:text="
														getProviderIdToName(account_manager_avatar.users_id)
													"
													@click="autoselect(account_manager_avatar)"
												/>
											</vx-tooltip>
										</div>
									</div>
								</div>
							</div>
							<div class="vx-row w-full my-3 ml-3" style="text-align: center">
								<div class="vx-row w-full">
									<vs-switch v-model="listActive" color="primary">
										<span slot="on">Achats historiques</span>
										<span slot="off">Achats historiques</span>
									</vs-switch>
								</div>
								<div
									class="vx-row w-full"
									style="padding: 10px 0 0 25px"
									v-if="listActive"
								>
									<div
										class="vx-row w-full"
										v-for="(
											purchaseMonth, indexPM
										) in purchasesHist.purchasesByMonth"
										:key="indexPM"
									>
										<div class="vx-row w-full">
											<h4>
												{{
													purchasesHist.dates[indexPM]
														.split("-")
														.reverse()
														.join("/")
												}}
											</h4>
										</div>
										<vs-table
											class="mb-2"
											:data="purchaseMonth"
											noDataText="Aucun achat"
										>
											<template slot-scope="{ data }">
												<vs-tr :key="indexP" v-for="(purchase, indexP) in data">
													<vs-td>
														<vx-tooltip
															v-if="purchase.user_id"
															:text="getCollaboratorName(purchase.user_id)"
															position="top"
														>
															<vs-avatar
																:src="getCollaboratorAvatar(purchase.user_id)"
															/>
														</vx-tooltip>
													</vs-td>
													<vs-td>{{
														getProviderIdToName(purchase.users_id)
													}}</vs-td>
													<vs-td>{{
														getServiceIdToName(purchase.service_id)
													}}</vs-td>
													<vs-td>{{
														purchase.is_billable
															? "Facturable"
															: "Pas Facturable"
													}}</vs-td>
													<vs-td>Commentaire : {{ purchase.commentary }}</vs-td>
													<vs-td>
														<vx-tooltip text="Dupliquer l'achat" position="top">
															<vs-button
																size="large"
																color="primary"
																type="flat"
																icon-pack="feather"
																icon="icon-copy"
																@click="renewPurchase(purchase)"
															></vs-button>
														</vx-tooltip>
													</vs-td>
												</vs-tr>
											</template>
										</vs-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="w-1/2 bg-gray-200 p-4">
						<div>
							<div
								class="w-1/2 flex"
								style="align-self: center; flex-wrap: wrap"
							>
								<div class="vx-col w-full" style="align-items: end">
									<!-- PRESTATION -->
									<label for="" class="vs-select--label"
										>Pour quelle prestation du contrat voulez-vous ajouter un
										achat ?</label
									>
									<div class="flex">
										<vs-select
											v-model="selectedProduct"
											class="w-full select-medium mr-2"
											:disabled="purchaseDefinitiveLock"
											no-data="Aucune prestation"
											autocomplete
											:style="styleValidator('selectedProduct')"
											@change="validateOne(selectedProduct, 'selectedProduct')"
											id="product_options"
										>
											<vs-select-item
												:key="index"
												:value="item[0]"
												:text="item[1]"
												v-for="(item, index) in productOptions"
												class="w-full"
											/>
										</vs-select>
										<vx-tooltip
											v-if="
												validators['selectedProduct'] &&
												validators['selectedProduct'].errText !== ''
											"
											:text="errText('selectedProduct')"
											class="ml-3"
										>
											<vs-icon
												icon="error"
												size="medium"
												style="color: red"
											></vs-icon>
										</vx-tooltip>
									</div>
								</div>

								<div
									class="vx-col mt-5 flex"
									style="align-items: end; justify-content: space-between"
								>
									<!-- SERVICE -->
									<div>
										<label for="" class="vs-select--label">Service</label>
										<div class="flex">
											<vs-select
												v-model="selectedService"
												class="w-full select-medium mr-2"
												no-data="Aucun service"
												autocomplete
												:style="styleValidator('selectedService')"
												@change="
													validateOne(selectedService, 'selectedService')
												"
											>
												<vs-select-item
													:key="index"
													:value="item.id"
													:text="item.name"
													v-for="(item, index) in serviceOptions"
													class="w-full"
												/>
											</vs-select>
											<vx-tooltip
												v-if="
													validators['selectedService'] &&
													validators['selectedService'].errText !== ''
												"
												:text="errText('selectedService')"
												class="ml-3"
											>
												<vs-icon
													icon="error"
													size="medium"
													style="color: red"
												></vs-icon>
											</vx-tooltip>
										</div>
									</div>
									<!-- PRESTATAIRE -->
									<div>
										<label for="" class="vs-select--label">Prestataire</label>
										<div class="flex">
											<vs-select
												v-model="selectedProvider"
												class="w-full select-medium mr-2"
												no-data="Aucun prestataire"
												autocomplete
												:style="styleValidator('selectedProvider')"
												@change="
													validateOne(selectedProvider, 'selectedProvider')
												"
											>
												<vs-select-item
													:key="index"
													:value="item.id"
													:text="item.society"
													v-for="(item, index) in providerOptions"
													class="w-full"
												/>
											</vs-select>
											<vx-tooltip
												v-if="
													validators['selectedProvider'] &&
													validators['selectedProvider'].errText !== ''
												"
												:text="errText('selectedProvider')"
												class="ml-3"
											>
												<vs-icon
													icon="error"
													size="medium"
													style="color: red"
												></vs-icon>
											</vx-tooltip>
										</div>
									</div>
									<!-- PRESTATAIRE -->
								</div>
							</div>
							<div class="vx-row" style="display: flex; align-items: end">
								<!-- PRIX D'ACHAT -->
								<div
									v-if="!is_dns && !is_netlink && serviceOptions.length > 0"
									class="vx-col sm:w-1/4 w-full mb-2 mt-2 nowrap"
								>
									<vs-input
										class="w-full"
										:disabled="purchaseLocked"
										label-placeholder="Prix d'achat"
										v-model="purchase.price"
										:style="styleValidator('price')"
										@change="validateOne(purchase.price, 'price')"
									/>
									€
									<vx-tooltip
										v-if="
											validators['price'] && validators['price'].errText !== ''
										"
										:text="errText('price')"
										class="ml-3"
									>
										<vs-icon
											icon="error"
											size="medium"
											style="color: red"
										></vs-icon>
									</vx-tooltip>
								</div>
								<!-- /PRIX D'ACHAT -->
								<!-- REFACTURABLE -->
								<div
									v-if="
										type != 'DNS' &&
										is_dns == false &&
										serviceOptions.length > 0
									"
									class="vx-col sm:w-1/4 w-full my-3"
								>
									<vs-checkbox
										:disabled="purchaseLocked || lockBillable"
										v-model="purchase.isBillable"
										>Facturable</vs-checkbox
									>
								</div>
								<!-- /REFACTURABLE -->

								<div
									v-if="
										type != 'DNS' &&
										is_dns == false &&
										purchase.isBillable &&
										serviceOptions.length > 0
									"
									class="vx-col sm:w-1/4 w-full my-3 nowrap"
								>
									<vs-input
										class="w-full my-3"
										:disabled="purchaseLocked"
										label-placeholder="Prix de vente"
										v-model="purchase.sellPrice"
										:style="styleValidator('sellPrice')"
										@change="validateOne(purchase.sellPrice, 'sellPrice')"
									/>
									€
									<vx-tooltip
										v-if="
											validators['sellPrice'] &&
											validators['sellPrice'].errText !== ''
										"
										:text="errText('sellPrice')"
										class="my-3"
									>
										<vs-icon
											icon="error"
											size="medium"
											style="color: red"
										></vs-icon>
									</vx-tooltip>
								</div>
							</div>
							<div
								class="vx-row w-full mb-2"
								style="margin-left: 0px; margin-top: 5px"
							>
								<vx-input-group class="bottom">
									<label
										for="flatpickr"
										style="font-size: 9px; margin-left: 3px"
										>Période</label
									>
									<br />
									<flat-pickr
										id="flatpickr"
										v-model="period"
										:config="configDatePicker"
										style="width: 100px; text-align: center"
										@keydown.native.delete.capture.stop.prevent
									/>
								</vx-input-group>
							</div>

							<div
								class="vx-row"
								v-if="is_dns || (!is_dns && serviceOptions.length > 0)"
							>
								<!-- COMMENTAIRE -->
								<div class="vx-col sm:w-1/4 w-full mb-2">
									<vs-input
										v-model="purchase.commentary"
										label="Commentaire"
										class="mb-0 md:mt-10 mt-6"
										:disabled="purchaseLocked"
									/>
								</div>
								<!-- /COMMENTAIRE -->
							</div>
						</div>
					</div>
				</div>

				<div class="vx-row">
					<!-- NETLINK POPUP -->
					<div class="vx-col w-full mb-2">
						<span v-if="is_netlink"
							><NetlinkPopupTable
								ref="netlinkPopup"
								:purchaseId="purchaseId"
								:societyId="societyId"
								@netlink-update="checkNetlinkNumber($event)"
						/></span>
						<span v-if="is_dns"
							><DnsPopupTable
								ref="dnsPurchasePopup"
								:purchaseId="purchaseId"
								:providerId="selectedProvider"
								:price="Number(purchase.price)"
						/></span>
					</div>
					<!-- /NETLINK POPUP -->
				</div>
				<!-- DESCRIPTION DU CONTRAT -->
				<div class="vx-row"></div>
				<!-- /DESCRIPTION DU CONTRAT -->
				<div class="vx-row float-right mt-3">
					<div class="vx-col w-full">
						<vs-button class="mb-2" @click="submitForm">Enregistrer</vs-button>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import VueCookies from "vue-cookies";
import MissionPopupTable from "@/components/tables/MissionPopupTable";
import NetlinkPopupTable from "@/components/tables/NetlinkPopupTable";
import DnsPopupTable from "@/components/tables/DnsPopupTable";
import Validator from "@/entities/Validator";
import Netlink from "@/entities/Netlink";
import Dns from "@/entities/Dns";
import Purchase from "@/entities/Purchase";
import Contract from "@/entities/Contract";
import Mission from "@/entities/Mission";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "HistoricalPurchasesPopup",
	mixins: [dbFieldConvertor],
	props: {
		missions: Array,
		missionId: Number,
		apiUrl: String,
		societies: Array,
		providers: Array,
		services: Array,
		products_categories: Array,
		contractId: Number,
		societyId: Number,
		societyName: String,
		popupActive: Boolean,
	},
	components: {
		flatPickr,
		monthSelect,
		MissionPopupTable,
		NetlinkPopupTable,
		DnsPopupTable,
		VxTooltip,
	},
	data() {
		return {
			// USER OBJECT
			purchase: Purchase.getFormFields(),
			// FORM SELECT OPTIONS
			statusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "Inactif", value: 0 },
			],
			frequencyOptions: [
				{ text: "One shot", value: 0 },
				{ text: "Mensuel", value: 1 },
				{ text: "Bimestriel", value: 2 },
				{ text: "Trimestriel", value: 3 },
				{ text: "Quadrimestriel", value: 4 },
				{ text: "Semestriel", value: 5 },
				{ text: "Annuel", value: 6 },
			],
			/**
			 * Refer to backend server to understand more about type and its possible value
			 */
			typeOptions: [
				{ text: "Commercial", value: 2 },
				{ text: "Consultant", value: 3 },
			],
			netlink_list: [],
			contractOptions: [],
			products: [],
			productOptions: [],
			providerOptions: [],
			serviceOptions: [],
			missionsOfSociety: [],
			selectedProduct: null,
			selectedProvider: null,
			selectedService: null,
			purchaseLocked: false,
			purchaseDefinitiveLock: false,
			lockBillable: false,
			editPurchaseMode: false,
			is_netlink: false,
			is_netlinkclient: false,
			netlinkServiceName: "Netlinking",
			netlinkClientServiceName: "Netlinking Client",
			dnsClientServiceName: "Domaine Client",
			netlinkServiceId: null,
			netlinkClientServiceId: null,
			dnsClientServiceId: null,
			is_dns: false,
			is_dnsclient: false,
			dnsServiceName: "Domaine",
			dnsServiceId: null,
			oneDns: null,
			showNetlinkPopup: false,
			showDnsPopup: false,
			atLeastOneNetlink: false,
			atLeastOneDns: false,
			purchaseId: null,
			configEndDatePicker: {
				// minDate: new Date(),
				dateFormat: "j/n/Y",
			},
			showMissionsPopup: false,
			// services: [],
			dnsServices: [],
			validators: {},
			check: true,
			isPopupActive: this.$props.popupActive,
			type: null,
			historicalProviders: [],
			listActive: true,
			purchasesHist: {},
			//period
			period: null,
			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
		};
	},

	created() {
		store.dispatch("getAllCollaborators");
		store.dispatch("getAllCollaboratorsAvatar");
		let today = new Date(Date.now());
		this.period = `${today.getMonth() + 1}/${today.getFullYear()}`;
		this.purchase.boughtAt = today.toISOString();
		this.getHistoricalPurchases();
		this.getAllMissionsForContract(this.$props.contractId);
		// this.getAllServices();
		if (this.$props.missionId) {
			this.purchaseDefinitiveLock = true;
			this.selectedProduct = this.$props.missionId;
		}
		this.serviceOptions = this.$props.services;
		try {
			console.log("sds11");
			console.log("sds", this.$props.missions);
		} catch (err) {
			console.log(err);
		}
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		// servicesList: () => {
		// 	return store.state.services;
		// },
	},
	watch: {
		selectedProduct: function (data) {
			//console.log("selectedProduct", data);0000000000000000000000000000000000000
		},
		selectedProvider: function (data) {
			//console.log("selectedProvider watch");
			this.purchase.users_id = data;
			// Filter Services
			// this.serviceOptions = this.setServiceOptions(data);
			// if (
			// 	this.serviceOptions.filter(
			// 		(service) => String(service.id) == this.selectedService
			// 	) <= 0
			// )
			// 	this.selectedService = this.serviceOptions[0].id;
		},

		selectedService: function (data) {
			//console.log("selectedService watch");

			this.is_netlink = this.checkServiceIsNetlink(data);
			this.is_dns = this.checkServiceIsDns(data);

			if (this.is_dns) {
				this.type = "DNS";
				this.getAllMissionsForContract(1);
			} else {
				this.type = "Other";
				this.getAllMissionsForContract(this.contractId);
			}

			this.purchase.service_id = data;
			// this.setProviderOptions(data);
			if (this.is_netlink == true) this.showNetlinkPopup = true;
			if (this.is_dns == true) this.showDnsPopup = true;
			this.is_dnsclient = data == this.dnsClientServiceId ? true : false;
			this.is_netlinkclient =
				data == this.netlinkClientServiceId ? true : false;
			if (this.is_dnsclient || this.is_netlinkclient) {
				this.purchase.isBillable = true;
				this.lockBillable = true;
			} else {
				this.lockBillable = false;
			}
			this.setProviderOptions(data);
			// if(this.providerOptions.length == 0 && !this.is_dns) this.selectedProvider = null;
		},
		is_netlink: function () {
			if (this.is_netlink) {
				//console.log("is_netlink", this.is_netlink);
			}
		},
		is_dns: function () {
			if (this.is_dns) {
				//console.log("is_dns", this.is_dns);
			}
		},
		services: function (data) {
			this.setNetlinkAndDnsId();
			if (this.type == "DNS") {
				//console.log("store.state.services", data);
				let dns_providers = [];
				let dns_service = data.filter(
					(service) => service.name == this.dnsServiceName
				);
				if (dns_service.length > 0) {
					this.dnsServices = dns_service;
					let dns_service_id = dns_service[0].id;
					//console.log("dns_service_id", dns_service_id);

					if (dns_service_id) {
						dns_providers = this.providers.filter((provider) => {
							let service_id_list = provider.service_id_list
								? provider.service_id_list.split(",")
								: [];
							//console.log(service_id_list);
							if (service_id_list.length > 0) {
								let service_id_found_index = service_id_list.findIndex(
									(service_id) => service_id == dns_service_id
								);
								if (service_id_found_index >= 0) return provider;
							}
						});
						//console.log("dns_providers", dns_providers);
					}
				}
			}
		},
	},
	methods: {
		validateOne(val, name) {
			//console.log(name, val);
			let value = val;
			if (value === 0) value = "0";
			let constname = "";
			if (name == "boughtAt") {
				constname = "dateConstraint";
				this.validators[name] = new Validator({ constraintName: constname });
				if (this.purchase.boughtAt == 0 || this.purchase.boughtAt == null) {
					this.validators[name].valid = false;
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.check = false;
				} else {
					this.validators["boughtAt"].errText = "";
					this.validators[name].valid = true;
				}
			} else {
				switch (name) {
					case "price":
					case "sellPrice":
						if (value) value = String(val);
						constname = "priceConstraint";
						break;
					default:
						if (value) value = String(val);
						if (value == null) value = "";
						constname = "isNumberConstraint";
						break;
				}
				this.validators[name] = new Validator({ constraintName: constname });
				this.validators[name].check(value);
				if (val == null) this.validators[name].valid = false;
				if (
					this.validators[name].valid == false &&
					this.validators[name].errText == ""
				) {
					this.validators[name].errText = "Ce champ ne peut être vide.";
					if ((name = "selectedProvider"))
						this.validators[name].errText = "Aucun prestataire trouvé.";
				}
				if (
					this.validators[name].valid == false &&
					this.validators[name].errText !== ""
				)
					this.check = false;
			}
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				switch (name) {
					case "boughtAt":
						return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid red !important; border-radius: 5px;";
				}
			} else if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].errText == ""
			) {
				switch (name) {
					case "boughtAt":
						return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid green !important; border-radius: 5px;";
				}
			} else {
				return "border: none !important; border-radius: none;";
			}
		},

		autoselect(thisProvider) {
			this.selectedService = thisProvider.service_id;
			this.selectedProvider = thisProvider.users_id;
			this.selectedProduct = thisProvider.mission_id;
		},

		addPurchase(isDNS = false, isNetlink = false) {
			return new Promise((resolve, reject) => {
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt
					? this.purchase.boughtAt.substring(0, 10)
					: today.toISOString().substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";

				let period = `${this.period
					.split("/")
					.reverse()
					.join("-")}-01 02:00:00`;

				if (isDNS == true) {
					this.$refs.dnsPurchasePopup.getPurchasePrice().then((result) => {
						this.purchase.price = result;
						this.$http
							.post(this.apiUrl + "purchase/add", {
								price:
									this.selectedService ==
									this.convertFrenchNumberToInternational(this.purchase.price),
								recurrence: this.purchase.recurrence,
								sell_price: this.convertFrenchNumberToInternational(
									this.purchase.sellPrice
								),
								margin_price: this.convertFrenchNumberToInternational(
									this.purchase.marginPrice
								),
								margin_rate: this.purchase.marginRate,
								is_billable: this.purchase.isBillable,
								commentary: this.purchase.commentary,
								bought_at: formatedDate,
								contract_id: 1,
								contract_society_id: this.societyId,
								users_id: this.selectedProvider,
								service_id: this.selectedService,
								is_delivered: 0,
								recurrence_active: this.purchase.recurrence,
								user_id: this.activeUser.id,
								period_date: period,
								mission_id: this.missionsOfSociety.filter(
									(mission) =>
										mission.contract_id == 1 && mission.products_id == 105
								)[0].id,
							})
							.then((res) => {
								this.isPopupActive = false;
								this.$vs.notify({
									title: "Succès",
									text: "Achat ajouté avec succès.",
								});
								resolve(res.data.insertId);
							})
							.catch((err) => {
								//console.log(err);
								this.$vs.notify({
									title: "Echec",
									text: "L'achat n'a pas été ajouté.",
								});
								reject(null);
							});
					});
				} else {
					this.$http
						.post(this.apiUrl + "purchase/add", {
							price: this.is_netlink
								? this.$refs.netlinkPopup.getPurchasePrice()
								: this.convertFrenchNumberToInternational(this.purchase.price),
							recurrence: this.purchase.recurrence,
							sell_price: this.convertFrenchNumberToInternational(
								this.purchase.sellPrice
							),
							margin_price: this.convertFrenchNumberToInternational(
								this.purchase.marginPrice
							),
							margin_rate: this.purchase.marginRate,
							is_billable: this.purchase.isBillable,
							commentary: this.purchase.commentary,
							bought_at: formatedDate,
							contract_id: this.contractId,
							contract_society_id: this.societyId,
							users_id: this.selectedProvider,
							service_id: this.selectedService,
							is_delivered: 0,
							recurrence_active: this.purchase.recurrence,
							user_id: this.activeUser.id,
							period_date: period,
							mission_id: this.selectedProduct,
						})
						.then((res) => {
							this.isPopupActive = false;
							this.$emit("refresh-data");
							this.$vs.notify({
								title: "Succès",
								text: "Achat ajouté avec succès.",
							});
							resolve(res.data.insertId);
						})
						.catch((err) => {
							//console.log(err);
							this.$vs.notify({
								title: "Echec",
								text: "L'achat n'a pas été ajouté.",
							});
							reject(null);
						});
				}
			});
		},

		addDNS() {
			// CREATE DNS OBJECT
			return new Promise((resolve, reject) => {
				this.oneDns = this.$refs.dnsPurchasePopup.getDnsData();
				//console.log("this.purchaseId", this.purchaseId);
				if (this.purchaseId) {
					//console.log(this.purchaseId);
					this.oneDns.purchase_id = this.purchaseId;
				}
				if (this.providerId) {
					//console.log(this.providerId);
					this.oneDns.provider_id = this.providerId;
				}
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt
					? this.purchase.boughtAt.substring(0, 10)
					: today.toISOString().substring(0, 10);

				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$refs.dnsPurchasePopup
					.submitAllDns(this.purchaseId, formatedDate, this.providerId)
					.then((result) => {
						resolve(result);
					})
					.catch((err) => {
						reject(err);
					});
				/*
				 * this.oneDns.purchase_date = formatedDate
				 * this.oneDns.renew_date = formatedDate
				 * let newDns = new Dns(this.oneDns)
				 * //console.log(newDns)
				 * newDns.create((err, res) => {
				 *   if(err){
				 *     //console.log(err)
				 *     reject(err)
				 *   }
				 *   if(res) {
				 *     //console.log(res)
				 *     this.$store.dispatch("getAllDns");
				 *     resolve(res.data.insertId)
				 *   }
				 * })
				 */
			});
		},

		createNetlink(isDNS, netlink) {
			return new Promise((resolve, reject) => {
				if (this.purchaseId) {
					netlink.purchase_id = this.purchaseId;
				}
				//console.log("this.societyId", this.societyId);
				if (this.societyId) {
					netlink.society_id = this.societyId;
				}

				//console.log("this.contractId", this.contractId);
				if (this.contractId) {
					netlink.contract_id = this.contractId;
				}

				netlink.create((err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							//console.log(res.data.insertId);
							this.$store.dispatch("getAllNetlink");
							netlink.id = res.data.insertId;
							resolve(res.data.insertId);
						}
				});
			});
		},

		addNetlink(isDNS = false) {
			// IMPLEMENT DNS LINKING
			return new Promise((resolve, reject) => {
				this.netlink_list = this.$refs.netlinkPopup.getNetlinkListData();
				let requests = [];
				for (let netlink of this.netlink_list) {
					netlink.contract_id = this.contractId;
					netlink.society_id = this.societyId;
					requests.push(this.createNetlink(isDNS, netlink));
				}
				Promise.all(requests).then((responses) => {
					resolve(responses);
				});
			});
		},

		submitForm() {
			this.check = true;
			let fields = [
				"selectedService",
				"selectedProvider",
				"selectedProduct",
				"price",
				"sellPrice",
			];
			let fieldsVal = [
				this.selectedService,
				this.selectedProvider,
				this.selectedProduct,
				this.purchase.price,
				this.purchase.sellPrice,
			];
			let constname = "";

			if (this.is_dns) {
				fields = ["selectedService", "selectedProvider", "price", "sellPrice"];
				fieldsVal = [
					this.selectedService,
					this.selectedProvider,
					this.purchase.price,
					this.purchase.sellPrice,
				];
			}

			for (let i = 0; i < fields.length; i++) {
				let value = fieldsVal[i];
				if (value === 0) value = "0";
				switch (fields[i]) {
					case "price":
					/*
					 * case "marginPrice":
					 * case "marginRate":
					 */
					case "sellPrice":
						if (value) value = String(value);
						constname = "priceConstraint";
						break;
					default:
						if (value) value = String(value);
						if (value == null) value = "";
						constname = "isNumberConstraint";
						break;
				}

				this.validators[fields[i]] = new Validator({
					constraintName: constname,
				});
				this.validators[fields[i]].check(value);
				if (fieldsVal[i] == null) this.validators[fields[i]].valid = false;
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				)
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
				if (fields[i] == "sellPrice" || fields[i] == "price") {
					if (
						!this.is_dns &&
						!this.is_netlink &&
						this.serviceOptions.length > 0
					) {
					} else {
						this.validators["price"].valid = true;
						this.validators["price"].errText = "";
					}
					if (
						this.type != "DNS" &&
						this.is_dns == false &&
						this.purchase.isBillable &&
						this.serviceOptions.length > 0
					) {
					} else {
						if (this.validators["sellPrice"]) {
							this.validators["sellPrice"].valid = true;
							this.validators["sellPrice"].errText = "";
						}
					}
				}
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText !== ""
				)
					this.check = false;
			}

			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.purchase.price = Number(
					String(this.purchase.price).replace(",", ".")
				);
				this.purchase.sellPrice = Number(
					String(this.purchase.sellPrice).replace(",", ".")
				);
				this.purchase.marginPrice = Number(
					String(this.purchase.marginPrice).replace(",", ".")
				);
				this.purchase.marginRate = Number(
					String(this.purchase.marginRate).replace(",", ".")
				);
				return new Promise((resolve, reject) => {
					if (this.selectedService == this.dnsServiceId) {
						this.addPurchase(true)
							.then((result) => {
								// Add DNS
								this.addDNS()
									.then((result2) => {
										this.isPopupActive = false;
										resolve(result2);
									})
									.catch((err2) => {
										//console.log(err2); reject(err2);
									});
							})
							.catch((err) => {
								//console.log(err); reject(err);
							});
					} else if (this.selectedService == 10) {
						// Purchase Netlink
						this.addPurchase()
							.then((result) => {
								// Add Netlink
								this.addNetlink()
									.then((result2) => {
										this.isPopupActive = false;
										resolve(result2);
									})
									.catch((err2) => {
										//console.log(err2); reject(err2);
									});
							})
							.catch((err) => {
								//console.log(err); reject(err);
							});
					} else {
						// Purchase Netlink
						this.addPurchase()
							.then((result) => {
								this.isPopupActive = false;
								resolve(result);
							})
							.catch((err) => {
								//console.log(err); reject(err);
							});
					}
				});
			}
		},

		/**
		 * Send the data to tha API to create the new purchase
		 */
		formSubmitted() {
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http
				.post(this.apiUrl + "purchase/add", {
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					recurrence: this.purchase.recurrence,
					sell_price: this.convertFrenchNumberToInternational(
						this.purchase.sellPrice
					),
					margin_price: this.convertFrenchNumberToInternational(
						this.purchase.marginPrice
					),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence,
					user_id: this.activeUser.id,
					mission_id: null,
				})
				.then((res) => {
					//console.log(res);
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Achat ajouté avec succès.",
					});
					this.$router.go(-1);
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "L'achat n'a pas été ajouté.",
					});
				});
		},

		/**
		 * Send the data to tha API to create the new purchase and show Netlink
		 */
		formSubmittedAndShowNetlink() {
			this.purchaseLocked = true;
			this.purchaseDefinitiveLock = true;
			this.showNetlinkPopup = true;
			/*
			 * let formatedDate = this.purchase.boughtAt.substring(0,10)
			 * formatedDate = formatedDate.split('/').reverse().join('-')
			 * formatedDate = formatedDate + " 02:00:00"
			 * this.$http.post(this.apiUrl + "purchase/add", {
			 *   price: this.convertFrenchNumberToInternational(this.purchase.price),
			 *   recurrence: this.purchase.recurrence,
			 *   margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
			 *   margin_rate: this.purchase.marginRate,
			 *   is_billable: this.purchase.isBillable,
			 *   commentary: this.purchase.commentary,
			 *   bought_at: formatedDate,
			 *   contract_id: this.purchase.contract_id,
			 *   contract_society_id: this.purchase.contract_society_id,
			 *   users_id: this.purchase.users_id,
			 *   service_id: this.purchase.service_id,
			 *   is_delivered: 0,
			 *   recurrence_active: this.purchase.recurrence,
			 *   user_id: this.activeUser.id
			 * }).then(res => {
			 *   //console.log(res)
			 *   this.purchaseId = res.data.insertId
			 *   //console.log(this.purchaseId)
			 *   this.showNetlinkPopup = true
			 *   this.$store.dispatch("getAllPurchasesWithRecurring");
			 *   // Send a success notification to the user
			 *   this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
			 * }).catch(err => {
			 *   //console.log(err)
			 *   this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
			 * })
			 */
		},

		formSubmittedAndShowDns() {
			/*
			 * this.purchaseLocked = true
			 * this.purchaseDefinitiveLock = true
			 * let formatedDate = this.purchase.boughtAt.substring(0,10)
			 * formatedDate = formatedDate.split('/').reverse().join('-')
			 * formatedDate = formatedDate + " 02:00:00"
			 * this.$http.post(this.apiUrl + "purchase/add", {
			 *   price: this.convertFrenchNumberToInternational(this.purchase.price),
			 *   recurrence: this.purchase.recurrence,
			 *   margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
			 *   margin_rate: this.purchase.marginRate,
			 *   is_billable: this.purchase.isBillable,
			 *   commentary: this.purchase.commentary,
			 *   bought_at: formatedDate,
			 *   contract_id: this.purchase.contract_id,
			 *   contract_society_id: this.purchase.contract_society_id,
			 *   users_id: this.purchase.users_id,
			 *   service_id: this.purchase.service_id,
			 *   is_delivered: 0,
			 *   recurrence_active: this.purchase.recurrence
			 * }).then(res => {
			 *   //console.log(res)
			 *   this.purchaseId = res.data.insertId
			 *   //console.log(this.purchaseId)
			 */
			this.showDnsPopup = true;
			/*
			 *   this.$store.dispatch("getAllPurchasesWithRecurring");
			 *   // Send a success notification to the user
			 *   this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
			 * }).catch(err => {
			 *   //console.log(err)
			 *   this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
			 * })
			 */
		},

		enterEditMode() {
			if (!this.atLeastOneNetlink && !this.atLeastOneDns) {
				this.purchaseDefinitiveLock = false;
			}
			this.showNetlinkPopup = false;
			this.showDnsPopup = false;
			this.editPurchaseMode = true;
			this.purchaseLocked = false;
		},

		/**
		 * Send the data to tha API to create the new netlinks
		 */
		netlinkSubmitted() {
			this.$router.go(-1);
		},

		updatePurchasePrice(purchasePrice, id) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(this.apiUrl + "purchase/editprice", {
						id: id,
						price: purchasePrice,
					})
					.then((result) => {
						resolve(true);
					});
			});
		},

		submitPurchase() {
			return new Promise((resolve, reject) => {
				let formatedDate = this.purchase.boughtAt.substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$http
					.post(this.apiUrl + "purchase/add", {
						price: this.convertFrenchNumberToInternational(this.purchase.price),
						sell_price: this.convertFrenchNumberToInternational(
							this.purchase.sellPrice
						),
						recurrence: this.purchase.recurrence,
						margin_price: this.convertFrenchNumberToInternational(
							this.purchase.marginPrice
						),
						margin_rate: this.purchase.marginRate,
						is_billable: this.purchase.isBillable,
						commentary: this.purchase.commentary,
						bought_at: formatedDate,
						contract_id: 1,
						contract_society_id: 206,
						users_id: this.purchase.users_id,
						service_id: this.purchase.service_id,
						is_delivered: 0,
						recurrence_active: this.purchase.recurrence,
						user_id: this.activeUser.id,
						mission_id: this.purchase.mission_id,
					})
					.then((res) => {
						//console.log(res);
						this.purchaseId = res.data.insertId;
						//console.log(this.purchaseId);
						this.$store.dispatch("getAllPurchasesWithRecurring");
						// Send a success notification to the user
						this.$vs.notify({
							title: "Succès",
							text: "Achat ajouté avec succès.",
						});
						resolve(res.data.insertId);
					})
					.catch((err) => {
						//console.log(err);
						this.$vs.notify({
							title: "Echec",
							text: "L'achat n'a pas été ajouté.",
						});
						reject(err);
					});
			});
		},

		dnsSubmitted() {
			// GET PURCHASE PRICE
			this.$refs.dnsPopup.getPurchasePrice().then((purchasePrice) => {
				this.purchase.price = purchasePrice;
				// SUBMIT PURCHASE
				this.submitPurchase().then((purchaseId) => {
					let formatedDate = this.purchase.boughtAt.substring(0, 10);
					formatedDate = formatedDate.split("/").reverse().join("-");
					formatedDate = formatedDate + " 02:00:00";
					// SUBMIT DNSs
					this.$refs.dnsPopup
						.submitAllDns(purchaseId, formatedDate, this.purchase.users_id)
						.then((dns_reponses) => {
							this.$vs.notify({
								title: "Succès",
								text: "Noms de domaines ajoutés avec succès.",
							});
							this.returnPrevRoute();
						})
						.catch((dns_err) => {
							this.$vs.notify({
								title: "Echec",
								text: "Une erreur est survenue lors de l'ajout des noms de domaines.",
							});
						});
				});
			});
			//console.log("dnsSubmitted");
		},

		displayMissionsPopup() {
			this.showMissionsPopup = true;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},

		getAllServices() {
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */

		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},
		getAllContractsForSociety(societyId) {
			Contract.getContractsforSociety(societyId, (err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						//console.log(res);
						this.contractOptions = res.filter((row) => row.status == 1);
						//console.log("this.contractOptions.length", this.contractOptions.length);
						if (this.contractOptions.length > 0) {
							this.contractId = this.contractOptions[0].id;
						} else {
							this.contractId = null;
						}
					}
			});
			//console.log("getAllContractsForSociety");
		},
		getAllMissionsForContract(contractId) {
			//console.log(contractId);
			try {
				Mission.getMissionsForContract(contractId, (err, res) => {
					if (err) console.log("Error in getMissionsForContract", err);
					if (res) {
						this.missionsOfSociety = res;

						this.$http.get(this.apiUrl + "product/all").then((result) => {
							this.products = result.data;

							let missionList = [];
							for (let mission of this.missionsOfSociety) {
								let item;

								/*
								 * if(mission.commentary){
								 * 	if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = `${this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform}: ${mission.commentary}`;
								 * }else{
								 * 	if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform;
								 * }
								 */
								if (mission.commentary) {
									if (
										this.products.filter(
											(product) => product.id == mission.products_id
										).length > 0
									)
										item = `${
											this.products.filter(
												(product) => product.id == mission.products_id
											)[0].perform
										}: ${mission.commentary}`;
								} else {
									if (
										this.products.filter(
											(product) => product.id == mission.products_id
										).length > 0
									)
										item = this.products.filter(
											(product) => product.id == mission.products_id
										)[0].perform;
								}
								//assging the product number to the mission in filtred misison
								if (item) {
									let thiPointMission = this.$props.missions.find(
										(ele) => ele.id == mission.id
									);
									//checking if mission exist or not excluding unnesccesary misison according to status
									if (thiPointMission)
										item = thiPointMission.products_number + " - " + item;
									else item = "";
								}
								if (item) missionList.push([mission.id, item]);
							}
							this.productOptions = missionList;
							if (this.productOptions.length > 0)
								this.selectedProduct = this.$props.missionId
									? this.$props.missionId
									: this.productOptions[0][0];
							else this.selectedProduct = null;
						});
					}
				});
			} catch (err) {
				console.log("Error in getAllMissionsForContract", err);
			}
			//console.log("getAllMissionsForContract");
		},

		getCollaboratorName(userId) {
			let foundCollaborator = this.allCollaborators.find(
				(collaborator) => collaborator.id == userId
			);
			if (foundCollaborator)
				return foundCollaborator.firstname + " " + foundCollaborator.lastname;
			else return null;
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		async getHistoricalPurchases() {
			await this.$http
				.get(this.apiUrl + "account_manager_view/purchase/" + this.contractId)
				.then((res) => {
					let list = [];
					for (let i = res.data[0].length - 1; i >= 0; i--) {
						let check = true;
						for (let item of list) {
							if (item.users_id == res.data[0][i].users_id) check = false;
						}
						if (check) list.push(res.data[0][i]);
						if (list.length == 4) break;
					}
					this.historicalProviders = list.reverse();
				})
				.catch((err) => {
					//console.log(err);
				});
			let date = new Date();
			let list = {
				dates: [
					String(date.getMonth() + 1).length == 2
						? date.getMonth() + 1 + "-" + date.getFullYear()
						: "0" + (date.getMonth() + 1) + "-" + date.getFullYear(),
					String(date.getMonth()).length == 2
						? date.getMonth() + "-" + date.getFullYear()
						: "0" + date.getMonth() + "-" + date.getFullYear(),
				],
				purchasesByMonth: [[], []],
			};
			await this.$http
				.get(
					this.apiUrl +
						"account_manager_view/contract/" +
						this.contractId +
						"/" +
						date.getFullYear() +
						"/" +
						(date.getMonth() + 1)
				)
				.then((res) => {
					list.purchasesByMonth[0] = res.data;
				})
				.catch((err) => {
					//console.log(err);
				});
			await this.$http
				.get(
					this.apiUrl +
						"account_manager_view/contract/" +
						this.contractId +
						"/" +
						date.getFullYear() +
						"/" +
						date.getMonth()
				)
				.then((res) => {
					list.purchasesByMonth[1] = res.data;
				})
				.catch((err) => {
					//console.log(err);
				});
			this.purchasesHist = list;
		},

		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined && service.name != undefined) {
				service_name = service.name;
			}
			return service_name;
		},

		getProviderIdToName(provider_id) {
			// let provider_name = ""
			let provider = this.providers.find(
				(provider) => provider.id == provider_id
			);
			let provider_name = provider ? provider.society : "";
			return provider_name;
		},

		renewPurchase(purchase) {
			this.selectedProvider = purchase.users_id;
			this.selectedService = purchase.service_id;
			this.selectedProduct = purchase.mission_id;

			this.$nextTick(() => {
				if (!this.is_dns && !this.is_netlink && this.serviceOptions.length > 0)
					this.purchase.price = purchase.price;
				else this.purchase.price = null;
				if (
					this.type != "DNS" &&
					this.is_dns == false &&
					this.serviceOptions.length > 0
				)
					this.purchase.isBillable = purchase.is_billable;
				else this.purchase.isBillable = 0;
				if (
					this.type != "DNS" &&
					this.is_dns == false &&
					this.purchase.isBillable &&
					this.serviceOptions.length > 0
				)
					this.purchase.sellPrice = purchase.sell_price;
				else this.purchase.sellPrice = null;
				if (this.is_dns || (!this.is_dns && this.serviceOptions.length > 0))
					this.purchase.commentary = purchase.commentary;
				else this.purchase.commentary = null;
			});
		},

		setProviderOptions(service_id) {
			let providerOptions = [];
			for (let i = 0; i < this.providers.length; i++) {
				if (this.providers[i].service_id_list) {
					let providerServices = this.providers[i].service_id_list.split(",");
					// //console.log("providerServices", providerServices, service_id)
					if (providerServices.includes(service_id.toString())) {
						// //console.log("INCLUDES")
						providerOptions.push(this.providers[i]);
					}
				}
			}

			// this.providers.filter(provider => provider.service_id_list.split(',').includes(service_id))
			this.providerOptions = providerOptions;
			if (providerOptions.length > 0) {
				this.selectedProvider = this.providerOptions[0].id;
			}
		},
		setServiceOptions(provider_id) {
			let foundProvider = this.providers.find(
				(provider) => provider_id == provider.id
			);
			let provider_service_id_list = foundProvider.service_id_list
				? foundProvider.service_id_list.split(",")
				: [foundProvider.service_id_list];
			if (provider_service_id_list.length > 0) {
				provider_service_id_list =
					this.type == "DNS"
						? provider_service_id_list.filter(
								(id) => id == this.dnsServices[0].id
						  )
						: provider_service_id_list;
				let formatedList = this.services.filter((service) =>
					provider_service_id_list.includes(String(service.id))
				);
				return formatedList;
			} else {
				return [];
			}
			// return this.type == "DNS" ? foundProvider.service_id_list.split(",") : foundProvider.service_id_list.split(",")
		},

		getServiceName(service_id) {
			let service = this.services.find(
				(service_element) => service_element.id == service_id
			);
			return service.name;
		},

		getServiceId(service_name) {
			let service = this.services.find(
				(service_element) => service_element.name == service_name
			);
			return service.id;
		},

		setNetlinkAndDnsId() {
			this.netlinkServiceId = this.getServiceId(this.netlinkServiceName);
			this.dnsServiceId = this.getServiceId(this.dnsServiceName);
			this.dnsClientServiceId = this.getServiceId(this.dnsClientServiceName);
			this.netlinkClientServiceId = this.getServiceId(
				this.netlinkClientServiceName
			);
		},

		// [netlinkServiceId, dnsServiceId].includes(selectedService)

		checkServiceIsNetlink(service_id) {
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined) {
				if (service.name == this.netlinkServiceName) {
					return true;
				}
			}
			return false;
		},

		checkServiceIsDns(service_id) {
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined) {
				if (service.name == this.dnsServiceName) {
					return true;
				}
			}
			return false;
		},

		checkNetlinkNumber(netlinkNumber) {
			if (netlinkNumber >= 1) {
				this.atLeastOneNetlink = true;
			} else {
				this.atLeastOneNetlink = false;
				if (!this.purchaseLocked) {
					this.purchaseDefinitiveLock = false;
				}
			}
		},

		checkDnsNumber(dnsNumber) {
			if (dnsNumber >= 1) {
				this.atLeastOneDns = true;
			} else {
				this.atLeastOneDns = false;
				if (!this.purchaseLocked) {
					this.purchaseDefinitiveLock = false;
				}
			}
		},
	},
};
</script>

<style>
#product_options > .input-select-con {
	width: 100%;
}

.nowrap {
	display: flex;
	align-items: baseline;
}

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}
</style>
